<template>
  <div>
    <div class="com-page-title">
      <div class="inner">{{ $route.meta.title }}</div>
    </div>
    <!-- 超荐莲位 -->
    <template v-if="payload.way?.indexOf('lianwei') > -1">
      <div class="com-card">
        <div class="com-card-title">往生者信息</div>
        <div class="com-card-content">
          <div class="com-form-wrap">
            <van-form class="com-form-vertical" ref="form1">
              <van-field
                class="field-yellow"
                v-model="form1.deadList[0].deadAppellation"
                :border="false"
                readonly
                clickable
                label="往生者称谓"
                placeholder="请选择往生者称谓"
                :rules="[{ required: true, message: '请选择往生者称谓' }]"
                @click="showAppellation = true"
              >
                <template #left-icon>仅限一人</template>
              </van-field>
              <van-field
                v-model="form1.deadList[0].deadName"
                :border="false"
                label="往生者姓名"
                :placeholder="selectedAppellation.placeholder"
                :rules="[{ required: !((selectedAppellation.appellation && selectedAppellation.nameHolder) || (selectedAppellation.appellation == '夭折婴灵' || selectedAppellation.appellation == '堕胎婴灵')), message: '请填写往生者姓名' }]"
                :disabled="selectedAppellation.appellation && selectedAppellation.nameHolder"
              />
              <!-- 245水陆法会、315  1120周年纪念日法会，独有 -->
              <template v-if="$getSpecialReligiousAssemblyRecord([245, 315]).includes(Number(payload.pId))">
                <van-field
                  v-model="form1.deadList[0].birthDate"
                  :border="false"
                  label="往生者生于（农历）"
                  placeholder="请填写出生日期或“吉年吉月吉日”"
                  :rules="[{ required: !((selectedAppellation.appellation && selectedAppellation.nameHolder) || (selectedAppellation.appellation == '夭折婴灵' || selectedAppellation.appellation == '堕胎婴灵' || selectedAppellation.appellation == '某氏门中历代宗亲')), message: '请填写出生日期或“吉年吉月吉日”' }]"
                  :disabled="(selectedAppellation.appellation && selectedAppellation.nameHolder) || (selectedAppellation.appellation == '夭折婴灵' || selectedAppellation.appellation == '堕胎婴灵' || selectedAppellation.appellation == '某氏门中历代宗亲')"
                />
                <van-field
                  v-model="form1.deadList[0].deathDate"
                  :border="false"
                  label="往生者卒于（农历）"
                  placeholder="请填写去世日期或“吉年吉月吉日”"
                  :rules="[{ required: !((selectedAppellation.appellation && selectedAppellation.nameHolder) || (selectedAppellation.appellation == '夭折婴灵' || selectedAppellation.appellation == '堕胎婴灵' || selectedAppellation.appellation == '某氏门中历代宗亲')), message: '请填写去世日期或“吉年吉月吉日”' }]"
                  :disabled="(selectedAppellation.appellation && selectedAppellation.nameHolder) || (selectedAppellation.appellation == '夭折婴灵' || selectedAppellation.appellation == '堕胎婴灵' || selectedAppellation.appellation == '某氏门中历代宗亲')"
                />
                <van-field
                  v-model="form1.deadList[0].address"
                  :border="false"
                  label="往生者在世时家庭住址"
                  placeholder="请填写往生者在世时家庭住址"
                  :rules="[{ required: !((selectedAppellation.appellation && selectedAppellation.nameHolder) || (selectedAppellation.appellation == '夭折婴灵' || selectedAppellation.appellation == '堕胎婴灵' || selectedAppellation.appellation == '某氏门中历代宗亲')), message: '请填写往生者在世时家庭住址' }]"
                  :disabled="(selectedAppellation.appellation && selectedAppellation.nameHolder) || (selectedAppellation.appellation == '夭折婴灵' || selectedAppellation.appellation == '堕胎婴灵' || selectedAppellation.appellation == '某氏门中历代宗亲')"
                />
              </template>
              <van-field
                v-model="form1.deadList[1].deadAppellation"
                readonly
                :border="false"
                label="往生者称谓（可选）"
                placeholder="请选择往生者称谓"
                :disabled="!selectedAppellation.appellation || selectedAppellation.relative.selectHolder"
                @click="handleShowAppellation2"
              >
                <template #left-icon>仅夫妻关系可选</template>
              </van-field>
              <van-field
                v-model="form1.deadList[1].deadName"
                :border="false"
                label="往生者姓名（可选）"
                :placeholder="selectedAppellation2.placeholder"
                :rules="[{ required: selectedAppellation2.appellation && !selectedAppellation2.selectHolder, message: '请选择往生者称谓' }]"
                :disabled="!selectedAppellation.appellation || selectedAppellation.relative.selectHolder"
              />
              <!-- 245水陆法会、315  1120周年纪念日法会，独有 -->
              <template v-if="$getSpecialReligiousAssemblyRecord([245, 315]).includes(Number(payload.pId))">
                <van-field
                  v-model="form1.deadList[1].birthDate"
                  :border="false"
                  label="往生者生于（农历）（可选）"
                  placeholder="请填写出生日期或“吉年吉月吉日”"
                  :rules="[{ required: selectedAppellation2.appellation && !selectedAppellation2.selectHolder, message: '请填写出生日期或“吉年吉月吉日”' }]"
                  :disabled="!selectedAppellation.appellation || selectedAppellation.relative.selectHolder"
                />
                <van-field
                  v-model="form1.deadList[1].deathDate"
                  :border="false"
                  label="往生者卒于（农历）（可选）"
                  placeholder="请填写去世日期或“吉年吉月吉日”"
                  :rules="[{ required: selectedAppellation2.appellation && !selectedAppellation2.selectHolder, message: '请填写去世日期或“吉年吉月吉日”' }]"
                  :disabled="!selectedAppellation.appellation || selectedAppellation.relative.selectHolder"
                />
              </template>
            </van-form>
          </div>
        </div>
      </div>
      <div class="com-card">
        <div class="com-card-title">阳上（供奉人）信息</div>
        <div class="com-card-content">
          <div class="com-form-wrap">
            <van-form class="com-form-vertical" ref="form2">
              <van-field
                v-model="form1.name"
                :border="false"
                label="阳上(供奉人)姓名"
                :placeholder="payload.size == 'da' ? selectedAppellation.placeholder2 : '示例：XXX'"
                :rules="[{ required: true, trigger: 'onBlur', message: '请填写姓名' }]"
              >
                <template #left-icon>
                  <span v-if="!payload.surnameNumber">{{ payload.size == 'da' ? '限三人以内' : '仅限一人' }}</span>
                  <span v-else>{{ payload.surnameNumber > 1 ? `限${['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '拾'][payload.surnameNumber]}人以内` : '仅限一人' }}</span>
                </template>
              </van-field>
              <van-field
                v-model="form1.mobile"
                :border="false"
                label="联系方式"
                placeholder="请填写手机号码"
                :rules="[{ required: true, trigger: 'onBlur', message: '请填写手机号码' }, { validator: $validate.phone, message: '手机号格式不正确' }]"
              />
            </van-form>
          </div>
        </div>
      </div>
    </template>
    <!-- 延生禄位 -->
    <div class="com-card" v-else>
      <div class="com-card-title">供奉人信息</div>
      <div class="com-card-content">
        <div class="com-form-wrap">
          <van-form class="com-form-vertical" ref="form3">
            <van-field
              v-model="form2.name"
              :border="false"
              label="供奉人姓名"
              placeholder="示例：XXX,XXX,…,XXX或XXX全家"
              :rules="[{ required: true, trigger: 'onBlur', message: '请填写供奉人姓名' }]"
              v-if="$getSpecialReligiousAssemblyRecord([225, 249, 309, 311, 312, 313]).includes(Number(payload.pId))"
            >
              <template #left-icon>限六人或一人及全家</template>
            </van-field>
            <van-field
              v-model="form2.name"
              :border="false"
              label="供奉人姓名"
              :placeholder="payload.size == 'da' ? '示例：XXX,XXX,XXX或XXX全家' : '示例：XXX'"
              :rules="[{ required: true, trigger: 'onBlur', message: '请填写供奉人姓名' }]"
              v-else
            >
              <template #left-icon>{{ payload.size == 'da' ? '限三人或一人及全家' : '仅限一人' }}</template>
            </van-field>
            <!-- 指定法会独有 -->
            <template v-if="$getSpecialReligiousAssemblyRecord([225, 245, 249, 309, 311, 312, 313, 315]).includes(Number(payload.pId))">
              <van-field
                v-model="form2.livingBirthDate"
                :border="false"
                label="供奉人生于（农历）"
                placeholder="请填写出生日期或“吉年吉月吉日”"
                :rules="[{ required: true, trigger: 'onBlur', message: '请填写出生日期或“吉年吉月吉日”' }]"
              />
              <van-field
                v-model="form2.livingAddress"
                :border="false"
                label="家庭住址"
                placeholder="请填写家庭住址"
                :rules="[{ required: true, trigger: 'onBlur', message: '请填写家庭住址' }]"
              />
            </template>
            <van-field
              v-model="form2.mobile"
              :border="false"
              label="联系方式"
              placeholder="请填写手机号码"
              :rules="[{ required: true, trigger: 'onBlur', message: '请填写手机号码' }, { validator: $validate.phone, message: '手机号格式不正确' }]"
            />
          </van-form>
        </div>
      </div>
    </div>
    <div class="com-card">
      <div class="com-card-title">详情</div>
      <div class="com-card-content">
        <div class="text-wrap">
          <p>{{ faHuiInfo.name }} - 供奉<DictionaryText typeCode="gongfengfangshi" :dictValue="payload.way"/>
            <template v-if="!['观音祈福', '除夕迎春祈福法会','元旦新春祈福法会'].includes(faHuiInfo.name)">
              - {{ payload.type == 1 ? '内坛 · ' : (payload.type == 2 ? '外坛 · ' : '') }}<DictionaryText typeCode="paiweidaxiao" :dictValue="payload.size" />
            </template>
          </p>
          <p>¥{{ payload.price }} x 1</p>
        </div>
      </div>
    </div>
    <div class="com-card">
      <div class="com-card-title">合计</div>
      <div class="com-card-content">
        <div class="text-wrap">
          <p class="t2">¥{{ payload.price }}</p>
        </div>
        <div class="com-form-submit">
          <DefaultBtn @click="validForm">支付</DefaultBtn>
        </div>
      </div>
    </div>

    <van-popup v-model:show="showAppellation" :close-on-click-overlay="false" position="bottom">
      <van-picker
        visible-item-count="5"
        :columns="appellationList.map(v => v.appellation)"
        @confirm="selectAppellation"
        @cancel="showAppellation = false"
      />
    </van-popup>
    <van-popup v-model:show="showAppellation2" :close-on-click-overlay="false" position="bottom">
      <van-picker
        visible-item-count="1"
        :columns="[selectedAppellation.relative].map(v => v.appellation)"
        @confirm="selectAppellation2"
        @cancel="cancel2"
      />
    </van-popup>
  </div>
</template>
 
<script>
  import DictionaryText from '@/components/common/DictionaryText'
  import { WxPay } from '@/utils/Pay'
  import appellationList from '@/assets/js/appellationList'
  export default {
    data () {
      return {
        // 法会详情
        faHuiInfo: {},
        // 超荐莲位对应关系
        appellationList: appellationList.filter(v => !v.hide),
        // 超荐莲位已选择的对应关系
        selectedAppellation: {
          relative: {}
        },
        selectedAppellation2: {},
        // 选择往生者称谓
        showAppellation: false,
        showAppellation2: false,

        payload: {},
        // 超荐莲位表单
        form1: {
          // 接收通知
          addWechat: 0,
          // 供奉人
          name: null,
          // 供奉人出生日期
          livingBirthDate: null,
          // 供奉人家庭住址
          livingAddress: null,
          // 供奉人手机号
          mobile: null,
          // 往生
          deadList: [
            {
              address: null,
              deadAppellation: null,
              deadName: null,
              birthDate: null,
              deathDate: null
            },
            {
              deadAppellation: null,
              deadName: null,
              birthDate: null,
              deathDate: null
            }
          ]
        },
        // 延生禄位表单
        form2: {
          // 接收通知
          addWechat: 0,
          // 供奉人
          name: null,
          mobile: null,
        }
      }
    },
    mounted () {
      this.getData()
      this.getFaHuiInfo()
    },
    methods: {
      // 获取法会信息
      getFaHuiInfo () {
        this.$faWuApi.faHui.getItemData({
          id: this.$route.query.pId
        }).then(res => {
          if (res.success) {
            this.faHuiInfo = res.data
          } else {
            this.$toast(res.errMessage)
          }
        })
      },
      cancel2 () {
        this.showAppellation2 = false
        this.selectAppellation(this.selectedAppellation.appellation)
      },
      // 往生者二选择picker
      handleShowAppellation2 () {
        if (this.selectedAppellation.appellation && !this.selectedAppellation.relative.selectHolder) {
          this.showAppellation2 = true
        }
      },
      // 选择往生者称谓
      selectAppellation (value) {
        this.selectedAppellation = appellationList.find(v => v.appellation == value)
        this.selectedAppellation2 = {}
        this.form1.deadList[0].deadAppellation = this.selectedAppellation.appellation
        this.form1.deadList[1].deadAppellation = null
        // 禁止名称写入的清空第一个名称
        if (this.selectedAppellation.nameHolder) {
          this.form1.deadList[0].deadName = null
        }
        // 没有对应关系的清空第二个名称
        if (this.selectedAppellation.relative.selectHolder) {
          this.form1.deadList[1].deadName = null
        }
        this.showAppellation = false
      },
      // 选择往生者称谓
      selectAppellation2 (value) {
        this.selectedAppellation2 = appellationList.find(v => v.appellation == value)
        this.form1.deadList[1].deadAppellation = this.selectedAppellation2.appellation
        this.showAppellation2 = false
      },
      // 详情
      getData () {
        this.$faWuApi.faHui.getSubDetail({
          id: this.$route.query.id
        }).then(res => {
          if (res.success) {
            this.payload = {
              pId: this.$route.query.pId,
              ...res.data
            }
            this.form1.orderPrice = this.payload.price
          }
        })
      },
      // 支付
      pay () {
        let form = {}
        // 超荐莲位
        if (this.payload.way.indexOf('lianwei') > -1) {
          form = {
            ...this.form1,
            deadList: this.form1.deadList.filter(v => {
              return v.deadAppellation
            })
          }
        }
        // 延生禄位
        else {
          form = this.form2
        }
        // 微信支付，因为该商户为子商户，没有回调功能，支付成功就完事了。。。
        new WxPay(Object.assign({
            liveList: [
              form
            ]
          }, {
          // 法会订单
          type: 1,
          // 后台管理订单详情里面后到
          orderType: JSON.stringify({
            key: 'fawu-fahui-paiwei',
            pId: this.payload.pId,
            way: this.payload.way
          }),
          goodsNum: 1,
          // 支付类型
          payWay: 'JSAPI',
          // 商品id
          goodsId: this.$route.query.id,
          // 价格
          orderPrice: this.payload.price,
          // orderPrice: 0.01
        }))
      },
      // 表单验证
      validForm () {
        let pList = []
        for (let i = 1; i <= 3; i ++) {
          if (this.$refs[`form${i}`]) {
            pList.push(new Promise((resolve, reject) => {
              this.$refs[`form${i}`].validate().then(err => {
                if (!err) {
                  resolve()
                } else {
                  reject()
                  }
              }).catch(reject)
            }))
          }
        }
        Promise.all(pList).then(() => {
          this.pay()
        }).catch(() => {
          this.$toast('请填写登记信息')
        })
      }
    },
    components: {
      DictionaryText
    }
  }
</script>